<template>
    <div>
        <Listing ref="listing" api="/users" :title="title" :fields="fields" :filters-schema="filtersSchema" :filters="filters" @new="onDetail()">
            <template #cell(actions)="{item}">
                <b-button variant="primary" size="sm" class="btn-label" @click="onDetail(item.id)">
                    <i class="bx bx-right-arrow-alt font-size-15 label-icon"></i>
                    <span>Détail</span>
                </b-button>
            </template>
        </Listing>

        <user-modal :user="selectedUser" @submited="onUserSubmited" />
    </div>
</template>

<script>
    import Layout from "../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Listing from "@/components/listing";
    import UserModal from "@/components/user-modal";

    export default {
        page: {
            title: "Liste des utilisateurs",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            Layout,
            PageHeader,
            Listing,
            UserModal
        },
        data: () => ({
            title: "Liste des utilisateurs",
            fields: [
                {
                    key: "code",
                    label: "Matricule"
                },
                { key: "nom" },
                { key: "fonction" },
                { key: "actions", label: "", tdClass: "w-0" }
            ],
            filters: {},
            filtersData: {},
            selectedYear: {},
            selectedUser: null,
            loading: false
        }),
        methods: {
            onDetail(user) {
                this.selectedUser = user;
                this.$nextTick(() => {
                    this.$bvModal.show("user-modal");
                });
            },
            onUserSubmited() {
                this.$refs.listing.loadData();
            },
            clearFilters() {
                this.filters = {};
            }
        },
        computed: {
            filtersSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row align-items-end",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Matricule",
                                    model: "code",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Nom",
                                    model: "nom",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "submit",
                                    buttonText: "Effacer",
                                    styleClasses: "col-auto",
                                    attributes: {
                                        class: "btn btn-light mb-1"
                                    },
                                    onSubmit: this.clearFilters
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>
